import styled from "styled-components";
import {
  Box as MuiBox,
  Select as MuiSelect,
  MenuItem as MuiMenuItem,
  InputLabel as MuiInputLabel,
  FormControl as MuiFormControl,
} from "@mui/material";
import { SelectRatingProps } from "./SelectRating";

export const Select = styled(MuiSelect)<{ width: number }>`
  &.MuiInputBase-root {
    width: ${(props) => props.width}px;
    height: 44px;
    color: #000000;
    font-size: 14px;
  }
`;

export const MenuItem = styled(MuiMenuItem)``;

export const InputLabel = styled(MuiInputLabel)`
  &.MuiFormLabel-root {
    background-color: white;
    padding: 0 4px;
  }
`;

export const FormControl = styled(MuiFormControl)``;

export const Wrap = styled(MuiBox)`
  &.MuiBox-root {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    gap: 16px;
  }
`;
